<!-- 登录 -->
<template>
  <div class="main">
    <div class="header" v-if="isLogin">
      <div class="logo"><span v-if="!menuShrink">万唯运营管理平台</span></div>
      <div @click="toggleMenu" class="toggleMenu" :class="[menuShrink?'el-icon-s-unfold':'el-icon-s-fold']" :style="{ left: menuWidth + 'rem' }"></div>
      <div class="userInfo">{{ userName }}, 您好 <span @click="logout">退出</span></div>
    </div>
    <div class="page">
      <div class="sideBar" v-if="isLogin" :style="{ width: menuWidth + 'rem' }">
        <div class="menu">
            <div class="parMenu" @click="showChild = !showChild" :style="{ width: menuWidth + 'rem' }" v-if="!menuShrink">
              <img src="../assets/images/icon-menu-tk.png" class="menu-icon" alt="">
              题库管理
              <i class="el-icon-arrow-down"
                style="margin-left: 30px;" v-if="showChild"></i><i class="el-icon-arrow-up" style="margin-left: 30rem;"
                v-else></i> 
            </div>
          <div :class="currentPage === 'books' ? 'childMenu' : 'childMenu_unselect'" v-show="showChild" :style="{ width: menuWidth + 'rem'}" v-if="!menuShrink" @click="toPage('books')">听说图书</div>
          <div :class="currentPage === 'special' ? 'childMenu' : 'childMenu_unselect'" v-show="showChild" :style="{ width: menuWidth + 'rem'}" v-if="!menuShrink" @click="toPage('special')">听说精练</div>
        </div>
        <div class="menu">
            <div :class="currentPage === 'logs' ? 'childMenu' : 'childMenu_unselect'" :style="{ width: menuWidth + 48 +  'rem'}" v-if="!menuShrink" @click="toPage('logs')" style="margin-left: -48rem;">
              <img src="../assets/images/icon-menu-log.png" v-show="currentPage !== 'logs'" class="menu-icon" alt="">
              <img src="../assets/images/icon-menu-logCheck.png" v-show="currentPage === 'logs'" class="menu-icon" alt="">
              操作日志
            </div>
        </div>
      </div>
      <div class="right" :class="{ pad: isLogin }">
        <div class="nav" v-if="isLogin">
          <div class="router" @click="goHome"> 
            {{goHomeText}} 
            
          </div>
          <span style="font-weight: bold;" v-if="showAddmodule">
              <span style="margin: 0 6rem;">/</span>
              模块管理</span>
        </div>
        <div class="container">
          <router-view />
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import { logout } from '@/api/user';
import { removeToken, getToken } from '@/utils/auth';

export default {
  name: "HomePage",
  components: {
  },
  data() {
    return {
      showChild: true,
      logVisible: false,
      menuShrink:false,
      menuWidth:210,
      menuMaxWidth:210,
      menuMinWidth:70,
      currentPage: 'special',//books：听说图书， special: 听说专项
      pageMenuArr: ['special','logs','addModule'],
      goHomeText: '地区管理',
      showAddmodule: false
    };
  },
  watch: {
      $route(to) {
          console.log('新路由:', to)
          this.menuTypeCheck(to.path);
          if (to.name === 'specialDetail') {
              console.log('showAddmodule:', this.showAddmodule)
              this.showAddmodule = true
          } else {
              this.showAddmodule = false
          }
      },
  },

  created() {
  },

  computed: {
    ...mapState(['userInfo']),
    isLogin() {
      if (this.userInfo.realName) {
        console.log('login')
      }
      return getToken()
    },
    userName() {
      if (this.userInfo.realName) {
        console.log('login')
      }
      let name = sessionStorage.getItem('name');
      return name
    }
  },

  methods: {
    goHome() {
        if (this.currentPage === 'books') {
            this.$router.push({
              path: '/'
            })
        } else if (this.currentPage === 'special') {
            this.$router.push({
              path: '/special'
            })
        }
      
      
    },
    logout() {
      logout().then(() => {
        removeToken();
        this.isLogin = false;
        sessionStorage.setItem('name', '')
        this.$store.commit('updateUserInfo', {})
        this.$router.push({
          path: '/login'
        })
      })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleMenu(){
      if(this.menuWidth == this.menuMinWidth){
        this.menuShrink = false
        this.menuWidth = this.menuMaxWidth
        this.setHtmlFontSize(0)

      } else{
        this.menuShrink = true
        this.menuWidth = this.menuMinWidth
        this.setHtmlFontSize(140)
      }
    },
    setHtmlFontSize(reduce) {
      const htmlEl = document.documentElement
      const fontSize = htmlEl.clientWidth / (1920 - reduce) < 0.65 ? 0.65: htmlEl.clientWidth / (1920 - reduce);
      htmlEl.style.fontSize = fontSize.toFixed(3) + "px";
    },
    toPage(pageName) {
        this.currentPage = pageName
        if (pageName === 'books'||pageName=='addModule'||pageName==='') {
            this.$router.push({
              path: '/'
            })
            this.goHomeText = '听说图书'
        } else if (pageName === 'special') {
            this.$router.push({
              path: '/special'
            })
            this.goHomeText = '听说精炼'
        } else if (pageName === 'logs') {
            this.$router.push({
              path: '/logs'
            })
            this.goHomeText = '操作日志'
        }
    },
    menuTypeCheck(name){
      let nameArr = name.split('/');
      if(nameArr.length>=2){
        if(nameArr[1]=='addModule'||nameArr[1]==''){
          this.currentPage = 'books';
        }else{
          this.currentPage = nameArr[1];
        }
      }
    }
  },
  mounted() {
    
  }
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.toggleMenu{
  position: absolute;
  color:var(--primary-color);
  transition: left 0.3s ease; /* 添加伸缩动画 */
  font-size: 20rem;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 45rem;
  background: #fff;
  font-size: 14rem;
  padding: 0 30rem;

  .logo {
    background-image: url(@/assets/images/minilogo.png);
    background-size: auto 95%;
    background-repeat: no-repeat;
    background-position: left bottom;
    display: flex;
    align-items: center;
    height: 33rem;
    padding-left: 37rem;
    font-weight: 700;
  }

  .userInfo {
    span {
      cursor: pointer;
    }
  }
}

.page {
  width: 100%;
  height: auto;
  background: #F0F2F5;
  flex: 1;
  display: flex;
  flex-direction: row;
}

.sideBar {
  // width: 210rem;
  transition: width 0.3s ease; /* 添加伸缩动画 */
  overflow: hidden; /* 隐藏超出宽度的内容 */
  background: linear-gradient(90deg, #0AC064 0%, #0AB17D 100%);

  .menu {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 14rem;
  }

  .parMenu {
    // width: 210rem;
    transition: width 0.3s ease; /* 添加伸缩动画 */
    height: 50rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .childMenu {
    // width: 210rem;
    transition: width 0.3s ease; /* 添加伸缩动画 */
    height: 50rem;
    background: #fff;
    color: var(--primary-color);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .childMenu_unselect {
    // width: 210rem;
    transition: width 0.3s ease; /* 添加伸缩动画 */
    height: 50rem;
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.right {
  flex: 1;
  display: flex;
  flex-direction: column;

  .nav {
    height: 50rem;
    display: flex;
    //justify-content: space-between;
    align-items: center;
    color: #4e5969;
    font-size: 14rem;

    .router {
      cursor: pointer;

      &:hover {
        color: var(--primary-color);
      }
    }

    .logBtn {
      width: 110rem;
      height: 32rem;
      border: 1rem solid #606266;
      border-radius: 6rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        margin-right: 8rem;
      }
    }
  }

  .container {
    flex: 1;
  }

  &.pad {
    padding: 0 20rem 20rem 20rem;
    box-sizing: content-box;
  }
}
.menu-icon{
  // width: 16rem;
  height: 16rem;
  margin-right: 10rem;
}
</style>
